import React, { useState, useEffect, useCallback } from 'react';
import { MailQuestion, FileText, Check, X } from 'lucide-react';
import { toast } from 'sonner';
import { eur } from '../ExpenseDetail/DetailKpis';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('admin_token')}`, 'Content-Type': 'application/json' });

const Item = ({ item, vendors, onDone }) => {
  const [vendorId, setVendorId] = useState('');
  const ex = item.extracted || {};
  const assign = async () => {
    const res = await fetch(`${API_URL}/api/admin/gastos/gmail/no-reconocidos/${item.id}/asignar`, { method: 'POST', headers: headers(), body: JSON.stringify({ vendor_id: vendorId }) });
    const j = await res.json();
    if (!res.ok) return toast.error(j.detail || 'Error');
    toast.success(j.possible_duplicate ? 'Asignada (marcada como posible duplicado)' : 'Asignada: ya está en pendientes');
    onDone();
  };
  const discard = async () => {
    await fetch(`${API_URL}/api/admin/gastos/gmail/no-reconocidos/${item.id}`, { method: 'DELETE', headers: headers() });
    onDone();
  };
  return (
    <div className="bg-white rounded-lg p-3 space-y-2 text-sm" data-testid={`unrecognized-${item.id}`}>
      <div className="flex items-start gap-2">
        <div className="flex-1 min-w-0">
          <p className="font-medium text-gray-900 truncate">{ex.vendor || 'Proveedor desconocido'} · {eur(ex.amount)}</p>
          <p className="text-xs text-gray-500 truncate">{item.sender_addr} · {item.subject}</p>
        </div>
        <a href={`${API_URL}${item.invoice_url}`} target="_blank" rel="noopener noreferrer" className="text-blue-600 shrink-0" data-testid={`unrecognized-pdf-${item.id}`}><FileText size={16} /></a>
      </div>
      <div className="flex gap-2">
        <select value={vendorId} onChange={e => setVendorId(e.target.value)} className="flex-1 min-w-0 h-9 rounded-md border px-2 text-sm" data-testid={`unrecognized-select-${item.id}`}>
          <option value="">Asignar a proveedor…</option>
          {vendors.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
        </select>
        <button onClick={assign} disabled={!vendorId} className="h-9 px-3 rounded-md bg-gray-900 text-white disabled:opacity-40" data-testid={`unrecognized-assign-${item.id}`}><Check size={15} /></button>
        <button onClick={discard} className="h-9 px-3 rounded-md border text-gray-500 hover:bg-gray-50" title="Descartar" data-testid={`unrecognized-discard-${item.id}`}><X size={15} /></button>
      </div>
    </div>
  );
};

export const UnrecognizedInvoices = ({ onChanged }) => {
  const [items, setItems] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [open, setOpen] = useState(false);

  const load = useCallback(() => {
    fetch(`${API_URL}/api/admin/gastos/gmail/no-reconocidos`, { headers: headers() }).then(r => r.json()).then(j => setItems(j.items || [])).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    fetch(`${API_URL}/api/admin/gastos/proveedores/autorizados`, { headers: headers() }).then(r => r.json()).then(j => setVendors(j.vendors || [])).catch(() => {});
  }, [load]);

  if (!items.length) return null;
  return (
    <div className="bg-violet-50 border border-violet-200 rounded-xl p-3 space-y-2" data-testid="unrecognized-invoices">
      <button onClick={() => setOpen(o => !o)} className="w-full text-left font-semibold text-violet-900 text-sm flex items-center gap-2" data-testid="unrecognized-toggle">
        <MailQuestion size={17} /> {items.length} factura{items.length > 1 ? 's' : ''} de remitentes no reconocidos
        <span className="ml-auto text-xs font-normal text-violet-700">{open ? 'Ocultar' : 'Revisar'}</span>
      </button>
      {open && items.map(i => <Item key={i.id} item={i} vendors={vendors} onDone={() => { load(); onChanged?.(); }} />)}
    </div>
  );
};
